import React from 'react';
import CtaBand from '../components/CtaBand';
import { CERTIFICATIONS, COMPANY, ABOUT } from '../constants/data';
import styles from './About.module.css';

export default function About() {
  return (
    <main className="page-wrapper">
      <div className="page-header">
        <div className={styles.headerInner}>
          <span className="eyebrow">Biz Kimiz</span>
          <h1>Hakkımızda</h1>
        </div>
      </div>

      <section className={styles.storySection}>
        <div className={styles.container}>
          <div className={styles.storyFull}>
            <span className="eyebrow">{ABOUT.eyebrow}</span>
            <h2 className={styles.storyHeading}>{ABOUT.heading}</h2>
            {ABOUT.paragraphs.map((p, i) => (
              <p key={i} className={styles.storyText}>{p}</p>
            ))}
            <div className={styles.badges}>
              {CERTIFICATIONS.map((c, i) => (
                <span key={i} className={styles.badge}>{c}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className={styles.valuesSection}>
        <div className={styles.container}>
          <div className="section-title">
            <span className="eyebrow">İlkelerimiz</span>
            <h2>Değerlerimiz</h2>
          </div>
          <div className={styles.valuesGrid}>
            {[
              { icon: '🛡', title: 'Güvenlik', desc: 'Her projede insan hayatı ve güvenliği en üst önceliktir. Tüm sistemlerimiz ilgili standartlara uygun test edilir.' },
              { icon: '⭐', title: 'Kalite', desc: 'Sadece orijinal, sertifikalı ürünler kullanıyoruz. İşçilik kalitemiz her projede aynı yüksek standarttadır.' },
              { icon: '🤝', title: 'Dürüstlük', desc: 'Müşterilerimize şeffaf fiyatlandırma ve dürüst iletişimle hizmet veriyoruz. Söz verdiğimizi yapıyoruz.' },
              { icon: '🔍', title: 'Yenilikçilik', desc: 'Sektördeki teknolojik gelişmeleri yakından takip eder, çözümlerimizi sürekli güncelliyoruz.' },
            ].map((v, i) => (
              <div key={i} className={styles.valueCard}>
                <div className={styles.valueIcon}>{v.icon}</div>
                <div className={styles.valueTitle}>{v.title}</div>
                <div className={styles.valueDesc}>{v.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </main>
  );
}
